import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class UserCourseCertificatesStateModel extends PaginatedSubentityStateModel {
    static identifier = 'UserCourseCertificatesStateModel';

    constructor() {
        super(UserCourseCertificatesStateModel.identifier);
    }
}
